module.exports = __webpack_public_path__ + "img/TurquoisePrincess_EGM.554b9a96.png";